import axios from "axios";
import Cookies from "js-cookie";

const authInterceptor = (config) => {
  //const token = localStorage.getItem("token");
  const token = Cookies.get("halasat-hr-token");
  config.headers["Authorization"] = `Bearer ${token}`;
  // config.headers["Content-Type"] = "application/json";
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname + window.location.search;

      if (!currentPath.includes("/login")) {
        window.location.href = `/login?redirect_url=${encodeURIComponent(
          currentPath,
        )}`;
      }
    }
    return Promise.reject(error);
  },
);

export default api;
